import React from "react"
import clsx from "clsx"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import ErrorHelper from "../../Errors/ErrorHelper"
import Cookies from 'js-cookie'

class HelperTemplateBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);
  };

  componentDidMount() {
    Cookies.set('help_type', 'room');
  }

 
  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">
        {ErrorHelper.renderErrors(this.props.errors, ['code', 'name', 'status', 'body'])}
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        <input type="hidden" name={this.inputName('id')} value={this.props.id || ''} />
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <br />
              <input type="text" name={this.inputName('code')} value={this.props.code} onChange={this.props.onChange.bind(this, 'code')} className={`form-control ${ErrorHelper.renderFieldClasses('code', this.props.errors)}`} data-model="HelperTemplate" data-column="code" />
            </div>
            {ErrorHelper.renderFieldErrors('code', this.props.errors)}   
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <br />
              <input type="text" name={this.inputName('name')} value={this.props.name} onChange={this.props.onChange.bind(this, 'name')} className={`form-control ${ErrorHelper.renderFieldClasses('name', this.props.errors)}`} data-model="HelperTemplate" data-column="name" />
            </div>
            {ErrorHelper.renderFieldErrors('name', this.props.errors)}   
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <br />
              <select name={this.inputName('status')} value={this.props.status} onChange={this.props.onChange.bind(this, 'status')} className={`form-control ${ErrorHelper.renderFieldClasses('status', this.props.errors)}`} data-model="HelperTemplate" data-column="status">
                <option value="published">{I18n.t('published')}</option>
                <option value="draft">{I18n.t('draft')}</option>
              </select>
              {ErrorHelper.renderFieldErrors('status', this.props.errors)}   
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group">    
              <label>{I18n.t('content')}</label>
              <br />                
              <RichTextEditor 
                height={230} 
                name={this.inputName('body')} 
                body={this.props.body} 
                onChange={this.props.onChange.bind(this, 'body')} 
                className={ErrorHelper.renderFieldClasses('body', this.props.errors)}  
                merge_tag_button={true} 
                agreement_forms={[]}
                survey_forms={[]}
                auto_resize={true} 
              /> 
              {ErrorHelper.renderFieldErrors('body', this.props.errors)}          
            </div>
          </div>
        </div>
      </div>
    );
  }

  inputName(name, obj) {
    var inputName = 'helper_template';

    inputName = inputName + name;

    return inputName;
  }

  // renderFieldClasses(field) {
  //   var classname = 'form-control';
  //   if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
  //     classname = classname + ' has-errors';
  //   }
  //   return classname;
  // }

};

export default HelperTemplateBuilderGeneral